import { Component } from '@angular/core';

@Component({
  selector: 'app-tunneling-equipment-info',
  templateUrl: './tunneling-equipment-info.component.html',
  styleUrls: ['./tunneling-equipment-info.component.scss']
})
export class TunnelingEquipmentInfoComponent {}
